import { render } from "./BasketModel.vue?vue&type=template&id=4bcedaf6&scoped=true"
import script from "./BasketModel.vue?vue&type=script&lang=js"
export * from "./BasketModel.vue?vue&type=script&lang=js"

import "./BasketModel.vue?vue&type=style&index=0&id=4bcedaf6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2385579202/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcedaf6"]])

export default __exports__